<template>
  <div>
    <v-layout align-center class="green--text mt-4 mb-2">
      <Icon name="share" class="mr-2" />  <h3>Partilhar com:</h3>
    </v-layout>
    <CollegueInputNew @updateSelectedUsers="updateSelectedUsers" />
  </div>
</template>
<script>
import CollegueInputNew from '@/views/Logbook/components/CollegueInputNew'
export default {
  components: {
    CollegueInputNew
  },
  data() {
    return {
      users: []
    }
  },

  methods: {
    updateSelectedUsers(selectedUsers) {
      this.users = selectedUsers
    }
  },
  watch: {
    users() {
      this.$emit('updateUsers', this.users)
    }
  }
}
</script>
